import React from 'react';
import DlpRules from '@Policy/DataLossPrevention/PolicyTemplate/Filters/Dlp';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

const DlpRulesExchange = () => {
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const mipFeatureShow = !!selectedOrgGlobalSetting?.mipFeatureShow;
  return (
    <DlpRules
      applyBoundShow={true}
      scanTargetShow={true}
      complianceRuleNoteShow={true}
      advancedOptionsShow={false}
      fileAdvancedOptionsShow={false}
      mipShow={mipFeatureShow}
      showHeaderScan={true}
      showApprovedSenders={true}
    />
  );
};
export default DlpRulesExchange;
